var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "email_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M3.23 7.118L24 26 44.77 7.118"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 44,
    height: 36,
    rx: 4
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+bWFpbDwvdGl0bGU+PGcgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzI3MjcyNiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+PHBvbHlsaW5lIGRhdGEtY2FwPSJidXR0IiBwb2ludHM9IjMuMjMgNy4xMTggMjQgMjYgNDQuNzcgNy4xMTgiIHN0cm9rZT0iIzI3MjcyNiI+PC9wb2x5bGluZT48cmVjdCB4PSIyIiB5PSI2IiB3aWR0aD0iNDQiIGhlaWdodD0iMzYiIHJ4PSI0Ij48L3JlY3Q+PC9nPjwvc3ZnPg==";
export { SvgEmail as ReactComponent };